// NOTE: This component will replace
// ContentListItemRow, ContentTypeListItemRow and ActionListItemRow
// It will be replaced in seperate PR since it will affect a large number of files

import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const ProtoContentListItemRow = ({ description, name, rightDetail }) => (
   <View
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      padding="12px"
      borderBottom="1px solid rgba(0,0,0,0.05)">
      <View
         flex="0 0 auto"
         width="30px"
         height="30px"
         borderRadius="3px"
         backgroundColor="#eee"
         marginRight="12px"
      />
      <View flex="1 1 auto" display="flex" alignItems="center">
         <View>
            <Text size="2" weight="medium">
               {name}
            </Text>
            <Text size="1" color="#888">
               {description}
            </Text>
         </View>
      </View>
      <View flex="0 0 auto">
         {rightDetail}
      </View>
   </View>
)

ProtoContentListItemRow.propTypes = {
   description: PropTypes.node,
   name: PropTypes.string.isRequired,
   rightDetail: PropTypes.node
}

ProtoContentListItemRow.defaultProps = {
   description: undefined,
   rightDetail: undefined
}

export default ProtoContentListItemRow
